<template>
  <div>
    <b-container variant="primary" fluid class="p-5">
      <b-row>
        <b-col :cols="12">
          <h2>Entretelas</h2>
          <p>En este apartado se pueden gestionar las entretelas.</p>
          <b-row class="mb-3">
            <b-col :cols="12"> </b-col>
          </b-row>

          <b-row>
            <b-col :cols="12">
              <h3>Listado de entretelas</h3>
              <v-server-table
                :url="table.url"
                ref="table"
                class="mt-4"
                :columns="table.columns"
                :options="table.options"
              >
                <div slot="afterFilterWrapper" class="form-group form-inline">
                  <b-button
                    class="ml-3"
                    variant="primary"
                    :to="{ name: 'AdminInterliningsNewScreen' }"
                    >Nueva entretela</b-button
                  >

                  <b-button
                    variant="outline-danger"
                    class="ml-2"
                    :disabled="table.selected.length === 0"
                    @click="removeSelected()"
                    >Eliminar seleccionadas</b-button
                  >
                </div>

                <div slot="h__checkbox">
                  <b-form-checkbox
                    v-model="table.allSelected"
                    @change="toggleAll"
                  />
                </div>

                <div slot="checkbox" slot-scope="props">
                  <b-form-checkbox
                    :checked="table.selected.includes(props.row.id)"
                    @change="toggleCell($event, props.row.id)"
                  />
                </div>

                <template v-slot:preview="props">
                  <img
                    style="max-height: 100px; max-width: 100px"
                    :src="props.row.icon"
                  />
                </template>

                <template v-slot:code_hex="props">
                  <span>#{{ props.row.code_hex }}</span>
                </template>

                <template v-slot:actions="props">
                  <b-button
                    :to="{
                      name: 'AdminInterliningsEditScreen',
                      params: { id: props.row.id },
                    }"
                    size="sm"
                    variant="outline-primary"
                    class="mr-2"
                    >Editar</b-button
                  >

                  <b-button
                    @click="removeInterlining(props.row.id)"
                    size="sm"
                    variant="outline-danger"
                    class="mr-2"
                    >Eliminar</b-button
                  >
                </template>
              </v-server-table>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { uris, actions } from '@/admin/api.js';

import store from '@/admin/store.js';

export default {
  name: 'AdminInterliningsScreen',
  props: {},
  components: {},
  data() {
    return {
      table: {
        url: uris.interliningsURI,
        selected: [],
        allSelected: false,
        columns: [
          'checkbox',
          'reference',
          'provider',
          'ref_provider',
          'actions',
        ],
        options: {
          sortable: ['reference'],
          headings: {
            reference: 'Nombre de entretela',
            name_es: 'Nombre',
            ref_provider: 'Ref. proveedor',
            provider: 'Proveedor',
            preview: 'Vista previa',
            actions: 'Acciones',
          },
        },
      },
      sharedState: store.state,
    };
  },
  created() {},
  methods: {
    removeSelected() {
      this.table.selected.map((x) => {
        this.removeInterlining(x);
      });
    },
    removeInterlining(id) {
      actions.deleteInterlining(id).then((x) => {
        this.$refs.table.refresh();
      });
    },
    toggleCell($event, id) {
      if ($event) {
        this.table.selected.push(id);
      } else {
        this.table.selected = this.table.selected.filter((item) => item !== id);
      }
    },
    toggleAll(checked) {
      this.table.selected = checked
        ? this.$refs.table.data.map((row) => row.id)
        : [];
    },
  },
  mounted() {},
};
</script>

<style scoped></style>
